import { useTranslation } from 'react-i18next';
import { getPaymentProviderDisplayName } from '@monorepo/client-common';
import {
  designTokens,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@monorepo/nova-ui';
import { ProviderData } from '@monorepo/types';

interface Props {
  providerData: ProviderData;
  updatedAt: string;
}

const InvoicePaymentDetails = ({ providerData, updatedAt }: Props) => {
  const { t } = useTranslation(['orders', 'common']);
  return (
    <TableContainer>
      <Table
        size="small"
        sx={{
          '& .MuiTableCell-root:first-of-type': { paddingLeft: 0 },
          '& .MuiTableCell-root:last-of-type': { paddingRight: 0 },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>
              <Typography
                variant="body2"
                fontWeight={designTokens.typography.fontWeights.medium}
              >
                {t('orders:preview_invoice.payment_details')}
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant="caption" color="text.secondary">
                {t('orders:preview_invoice.method')}
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography
                variant="body2"
                fontWeight={designTokens.typography.fontWeights.medium}
              >
                {providerData.name
                  ? t(getPaymentProviderDisplayName(providerData.name) as any)
                  : t('common:not_available')}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="caption" color="text.secondary">
                {t('orders:preview_invoice.date_paid')}
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography
                variant="subtitle2"
                fontWeight={designTokens.typography.fontWeights.regular}
              >
                {updatedAt}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoicePaymentDetails;
